import { consumePendingLogoutRedirect } from '@helpers/consumePendingLogoutRedirect';
import { useInitContext } from '@providers/InitProvider';
import { useEffect, useRef } from 'react';

export const PendingLogoutRedirect = () => {
  const { isAuthenticated } = useInitContext();
  const hasConsumed = useRef(false);

  useEffect(() => {
    if (hasConsumed.current) {
      return;
    }

    hasConsumed.current = true;
    const pendingPath = consumePendingLogoutRedirect();
    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    if (!pendingPath || isAuthenticated || pendingPath === currentPath) {
      return;
    }

    window.location.replace(pendingPath);
  }, []);

  return null;
};
